import {
    Component,
    Input,
    OnInit,
    OnChanges,
    effect,
} from '@angular/core';
import { IdentifierService } from 'merlin-core';
import { UserService } from 'merlin-library';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { EnrollPatientDeviceDataService } from '../../../../services/enroll-patient-device-data.service';
import * as _ from 'lodash-es';
@Component({
    selector: 'view-direct-call-messaging',
    templateUrl: './view-direct-call-messaging.component.html',
    styleUrls: ['./view-direct-call-messaging.component.scss'],
    standalone: false,
})
export class ViewDirectCallMessagingComponent implements OnInit, OnChanges {
    public implantselectedItem;
    medTeam: any;
    clinicans: any[];
    isSP2Clinic: boolean;
    isOtherPhone: boolean = false;
    isPrimaryMobile: boolean = false;

    @Input() functionMode: string;
    @Input() displayMode: string;
    @Input() patRes: any;
    @Input() userProfile: any;

    public stringLabels = [
        "label.gb.direct_msgng",
        "label.gb.get_permission",
        "label.gb.auto_followup_reminders",
        "label.gb.auto_overdue_msg",
        "label.gb.notify_patient",
        "label.gb.between",
        "label.gb.and",
        "label.gb.drctcall_mthd",
        "label.gb.std_rates_apply",
        "label.gb.other_phone",
        "label.gb.text_msg_info",
        "label.gb.std_rates_apply",
        "label.rpt.medical_team",
        "label.gb.place_med_team_after_hours_notif_order_blue",
        "label.gb.am",
        "label.gb.pm"
    ]

    public labels: Record<string, string>;

    constructor(
        private localizationService: LocalizationService,
        public identifierService: IdentifierService,
        private userService: UserService,
        public deviceDataService: EnrollPatientDeviceDataService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
    }

    ngOnInit() {
        this.translateStrings();
        this.getUserData();
        this.medTeam = this.patRes?.medTeam;
        this.clinicans = this.patRes?.dropdowns?.clinicians;
        if (this.medTeam.implantPhyId != null) {
            this.implantselectedItem = this.medTeam.implantPhyId;
        } else {
            this.implantselectedItem = 999999;
        }
        this.mapPhysLists();
    }

    ngAfterViewInit() {

    }

    ngOnChanges() {
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    displayViewUI() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    getCallMethod() {
        let patChamb = this.patRes?.dropdowns?.contactTypeCodes.filter(
            (code) => {
                return code.codeId == this.patRes?.messaging?.callContactTypeCd;
            }
        );
        if (!patChamb) {
            return '';
        }
        if(patChamb?.length > 0){
        if (patChamb[0].code === 'SMSO') {
            this.isOtherPhone = true;
        }
        if (patChamb[0].code === 'SMSP') {
            this.isPrimaryMobile = true;
        }
        return this.translate('data.Code.Patient_Call_Contact_Type_Cd.Code_Desc.'+patChamb[0].code);
       }
       return '';
    }

    getUserData() {
        this.isSP2Clinic =
                    this.userProfile.customerType === 'CL'
                        ? true
                        : this.userProfile?.customerType === 'SP2'
    }

    getPhys(phys) {
        let patPhys = this.patRes?.dropdowns?.clinicians.filter((dev) => {
            return dev.acctId == phys;
        });
        if (!patPhys || patPhys?.length == 0) {
            return '';
        }

        const oncall_physician = "label.gb.oncall_physician";
        const lName = patPhys[0]?.lastName === oncall_physician ?
        this.translate(oncall_physician) : patPhys[0]?.lastName ? patPhys[0]?.lastName + ", " : '' ;
        const fName = patPhys[0]?.firstName ? patPhys[0]?.firstName + " ": '';
        const mName = patPhys[0]?.middleName ? patPhys[0]?.middleName + " " : '';
        const location = (patPhys[0]?.mainLocation && this.isSP2Clinic) ? patPhys[0]?.mainLocation + ': ' : '';

        return patPhys[0]?.credentialsCd ? location + lName + fName + mName + patPhys[0].credentialsCd : location + lName + fName + mName;
    }

    isViewImplanting(id: any) {
        return id == this.implantselectedItem;
    }

    mapPhysLists() {
        if (this.medTeam?.assigned) {
            this.medTeam.assigned = _.sortBy(this.medTeam?.assigned, [
                function (o) {
                    return o.order;
                },
            ]);
        }
    }

    translate(key: string) {
        return this.localizationService.generateLocalizedStr(key);
    }
}
